import React from 'react';
import PropTypes from 'prop-types';
import './PageHeader.scss';

function PageHeader({ title }) {
  return <div className="page-header">{title}</div>
}

PageHeader.propTypes = {
  title: PropTypes.node.isRequired,
};

export default PageHeader;
